import { useState, useEffect, useCallback, useRef } from "react";
import api from "../api";
import { etapasKanban, carregarFunil, primeiraEtapa } from "../funil";
import { useTheme } from "../components/Theme";

// etapas do funil: as mesmas da tela de Negociacoes, definidas por empresa
let STAGES = etapasKanban();

const ORIGENS = ["Instagram","Google","Indicação","WhatsApp","Facebook","Site","Outro"];

function fmt(v) { return v ? `R$${Number(v).toLocaleString("pt-BR")}` : ""; }

// Card de lead no kanban
function KanbanCard({ lead, onOpen, onStageChange }) {
  const [dragOver, setDragOver] = useState(false);
  const et = STAGES.find(s=>s.id===lead.stage)||STAGES[0];

  return (
    <div draggable
      onDragStart={e=>{ e.dataTransfer.setData("leadId",lead._id); e.dataTransfer.setData("fromStage",lead.stage); }}
      onClick={()=>onOpen(lead)}
      style={{ background:"var(--card-bg)", borderRadius:8, border:"1px solid var(--border-color)", padding:"12px 14px", marginBottom:8, cursor:"pointer", boxShadow:"0 1px 4px rgba(0,0,0,.05)", transition:"box-shadow .15s, transform .1s" }}
      onMouseEnter={e=>{ e.currentTarget.style.boxShadow="0 4px 12px rgba(0,0,0,.1)"; e.currentTarget.style.transform="translateY(-1px)"; }}
      onMouseLeave={e=>{ e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,.05)"; e.currentTarget.style.transform="none"; }}>

      {/* Nome */}
      <div style={{ fontSize:13, fontWeight:600, color:"var(--text-primary)", marginBottom:4, lineHeight:1.4 }}>{lead.nome}</div>

      {/* Empresa */}
      {lead.empresa&&<div style={{ fontSize:12, color:"var(--text-secondary)", marginBottom:8 }}>{lead.empresa}</div>}

      {/* Footer */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginTop:8, gap:6, flexWrap:"wrap" }}>
        {lead.valor>0&&(
          <span style={{ fontSize:12, fontWeight:700, color:"#EE6A1A", background:"#FDE7DA", borderRadius:99, padding:"2px 8px" }}>
            {fmt(lead.valor)}
          </span>
        )}
        {lead.origem&&(
          <span style={{ fontSize:11, color:"var(--text-secondary)", background:"var(--hover-bg)", borderRadius:99, padding:"2px 8px" }}>{lead.origem}</span>
        )}
        {lead.nomeResponsavel&&(
          <div style={{ width:22, height:22, borderRadius:"50%", background:"#EE6A1A22", border:"2px solid #EE6A1A55", display:"flex", alignItems:"center", justifyContent:"center", fontSize:9, fontWeight:700, color:"#EE6A1A" }}>
            {lead.nomeResponsavel.split(" ").slice(0,2).map(n=>n[0]).join("").toUpperCase()}
          </div>
        )}
      </div>

      {/* Barra de probabilidade */}
      {lead.probabilidade>0&&(
        <div style={{ marginTop:8, background:"var(--hover-bg)", borderRadius:99, height:4, overflow:"hidden" }}>
          <div style={{ width:`${lead.probabilidade}%`, background:et.color, height:"100%", borderRadius:99 }}/>
        </div>
      )}
    </div>
  );
}

// Modal lead
function ModalLead({ lead, onClose, onSave, onDelete }) {
  const isNew = !lead?._id;
  const [form, setForm] = useState({
    nome:lead?.nome||"", empresa:lead?.empresa||"", telefone:lead?.telefone||"",
    email:lead?.email||"", valor:lead?.valor||"", probabilidade:lead?.probabilidade||"",
    origem:lead?.origem||"Instagram", stage:lead?.stage||primeiraEtapa(), obs:lead?.obs||"",
    nomeResponsavel:lead?.nomeResponsavel||"",
  });
  const [nota, setNota] = useState("");
  const [load, setLoad] = useState(false);
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  const inp={ width:"100%", boxSizing:"border-box", background:"var(--hover-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"9px 12px", color:"var(--text-primary)", fontSize:13, outline:"none", fontFamily:"'Inter',sans-serif" };
  const et = STAGES.find(s=>s.id===form.stage)||STAGES[0];

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.4)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={onClose}>
      <div style={{ background:"var(--card-bg)", borderRadius:16, padding:28, width:"100%", maxWidth:520, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,.2)" }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
              <div style={{ width:10, height:10, borderRadius:2, background:et.color }}/>
              <span style={{ fontSize:12, color:et.color, fontWeight:600 }}>{et.label}</span>
            </div>
            <h2 style={{ margin:0, fontSize:18, fontWeight:700, color:"var(--text-primary)" }}>{form.nome||"Novo lead"}</h2>
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", color:"var(--text-secondary)", fontSize:20 }}>×</button>
        </div>

        {/* Stage selector */}
        <div style={{ marginBottom:16 }}>
          <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:8, letterSpacing:".04em", textTransform:"uppercase" }}>Etapa</label>
          <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
            {STAGES.map(s=>(
              <button key={s.id} onClick={()=>set("stage",s.id)}
                style={{ padding:"4px 10px", borderRadius:6, fontSize:12, fontWeight:600, cursor:"pointer", border:`1.5px solid ${form.stage===s.id?s.color:"var(--border-color)"}`, background:form.stage===s.id?s.bg:"var(--card-bg)", color:form.stage===s.id?s.color:"var(--text-secondary)" }}>
                {s.label}
              </button>
            ))}
          </div>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
          {[["Nome *","nome"],["Empresa","empresa"],["Telefone","telefone"],["Email","email"]].map(([label,key])=>(
            <div key={key}>
              <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
              <input value={form[key]||""} onChange={e=>set(key,e.target.value)} style={inp}
                onFocus={e=>{ e.target.style.borderColor="#EE6A1A"; e.target.style.boxShadow="0 0 0 3px #EE6A1A18"; }}
                onBlur={e=>{ e.target.style.borderColor="var(--border-color)"; e.target.style.boxShadow="none"; }}/>
            </div>
          ))}
          {[["Valor (R$)","valor","number"],["Probabilidade %","probabilidade","number"]].map(([label,key,type])=>(
            <div key={key}>
              <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
              <input type={type} value={form[key]||""} onChange={e=>set(key,e.target.value)} style={inp}
                onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}/>
            </div>
          ))}
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>Origem</label>
            <select value={form.origem} onChange={e=>set("origem",e.target.value)} style={{ ...inp, appearance:"auto" }}
              onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}>
              {ORIGENS.map(o=><option key={o}>{o}</option>)}
            </select>
          </div>
        </div>

        <div style={{ marginBottom:14 }}>
          <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:5, letterSpacing:".04em", textTransform:"uppercase" }}>Observações</label>
          <textarea value={form.obs||""} onChange={e=>set("obs",e.target.value)} rows={2} style={{ ...inp, resize:"vertical" }}
            onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}/>
        </div>

        {!isNew&&lead?.atividades?.length>0&&(
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", display:"block", marginBottom:8, letterSpacing:".04em", textTransform:"uppercase" }}>Histórico</label>
            {[...lead.atividades].reverse().slice(0,3).map((a,i)=>(
              <div key={i} style={{ background:"var(--hover-bg)", borderRadius:8, padding:"8px 12px", marginBottom:6 }}>
                <div style={{ display:"flex", justifyContent:"space-between", marginBottom:3 }}>
                  <span style={{ color:"#EE6A1A", fontWeight:600, fontSize:12 }}>{a.nomeUsuario}</span>
                  <span style={{ fontSize:11, color:"var(--text-secondary)" }}>{new Date(a.createdAt).toLocaleDateString("pt-BR")}</span>
                </div>
                <div style={{ fontSize:13, color:"var(--text-primary)" }}>{a.descricao}</div>
              </div>
            ))}
          </div>
        )}

        {!isNew&&(
          <div style={{ display:"flex", gap:8, marginBottom:14 }}>
            <input value={nota} onChange={e=>setNota(e.target.value)} placeholder="Adicionar nota..." style={{ ...inp, flex:1 }}
              onFocus={e=>e.target.style.borderColor="#EE6A1A"} onBlur={e=>e.target.style.borderColor="var(--border-color)"}/>
            <button onClick={async()=>{ if(!nota.trim()) return; await api.post(`/leads/${lead._id}/atividades`,{tipo:"nota",descricao:nota}); setNota(""); onClose(); }}
              style={{ background:"#EE6A1A", border:"none", borderRadius:8, padding:"9px 14px", color:"#fff", cursor:"pointer", fontSize:13, fontWeight:700 }}>+</button>
          </div>
        )}

        <div style={{ display:"flex", gap:8 }}>
          <button onClick={async()=>{ if(!form.nome.trim()) return alert("Nome obrigatório"); setLoad(true); try{await onSave({...lead,...form,tipo:"lead"});}finally{setLoad(false);} }} disabled={load}
            style={{ flex:1, background:"#EE6A1A", border:"none", borderRadius:8, padding:"12px 0", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", opacity:load?.7:1 }}>
            {load?"Salvando...":"Salvar"}
          </button>
          {!isNew&&<button onClick={()=>onDelete(lead._id)} style={{ background:"#feecec", border:"1px solid #f9d3d3", borderRadius:8, padding:"12px 16px", color:"#e2445c", fontWeight:600, fontSize:13, cursor:"pointer" }}>Excluir</button>}
        </div>
      </div>
    </div>
  );
}

export default function Kanban({ onStageChange, leadIdParaAbrir, currentUser }) {
  const { theme } = useTheme();
  const [leads,   setLeads]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState("");
  const [modal,   setModal]   = useState(null);
  const [filtro,  setFiltro]  = useState("meus");
  const [dragOver, setDragOver] = useState(null);
  const [, recarregarFunil] = useState(0);
  useEffect(() => { carregarFunil().then((l) => { STAGES = etapasKanban(l); recarregarFunil((v) => v + 1); }); }, []);

  const carregar = useCallback(async()=>{
    try{
      const{data}=await api.get("/leads?limit=2000&tipo=lead");
      setLeads(data.leads);
    }catch{}finally{ setLoading(false); }
  },[]);

  useEffect(()=>{ carregar(); },[carregar]);

  useEffect(()=>{
    if(leadIdParaAbrir){
      const l=leads.find(x=>x._id===leadIdParaAbrir);
      if(l) setModal(l);
    }
  },[leadIdParaAbrir,leads]);

  const moverStage=async(leadId,novoStage)=>{
    const lead=leads.find(l=>l._id===leadId);
    if(!lead||lead.stage===novoStage) return;
    await api.patch(`/leads/${leadId}/stage`,{stage:novoStage});
    setLeads(prev=>prev.map(l=>l._id===leadId?{...l,stage:novoStage}:l));
    if(onStageChange) onStageChange(lead,lead.stage,novoStage);
  };

  const salvarLead=async(f)=>{
    if(f._id){ const{data}=await api.put(`/leads/${f._id}`,f); setLeads(prev=>prev.map(l=>l._id===data._id?data:l)); }
    else{ const{data}=await api.post("/leads",{...f,tipo:"lead",stage:f.stage||"prospeccao"}); setLeads(prev=>[data,...prev]); }
    setModal(null);
  };
  const excluirLead=async(id)=>{ if (!window.confirm("Excluir este lead?")) return; await api.delete(`/leads/${id}`); setLeads(prev=>prev.filter(l=>l._id!==id)); setModal(null); };

  const filtered = leads.filter(l=>{
    const q=search.toLowerCase();
    const matchSearch=!q||l.nome?.toLowerCase().includes(q)||l.empresa?.toLowerCase().includes(q);
    const matchFiltro=filtro==="todos"||!currentUser||l.nomeResponsavel===currentUser.nome||!l.nomeResponsavel;
    return matchSearch&&matchFiltro;
  });

  const porStage=(stage)=>filtered.filter(l=>l.stage===stage);
  const totalValor=(stage)=>porStage(stage).reduce((a,l)=>a+Number(l.valor||0),0);

  return (
    <div style={{ fontFamily:"'Inter',-apple-system,sans-serif", background:"var(--hover-bg)", minHeight:"100vh" }}>
      {/* Header */}
      <div style={{ background:"var(--card-bg)", borderBottom:"1px solid var(--border-color)", padding:"14px 24px", display:"flex", gap:12, alignItems:"center" }}>
        <input placeholder="🔍 Pesquisar..." value={search} onChange={e=>setSearch(e.target.value)}
          style={{ background:"var(--hover-bg)", border:"1.5px solid var(--border-color)", borderRadius:8, padding:"7px 12px", color:"var(--text-primary)", fontSize:13, outline:"none", width:220, fontFamily:"'Inter',sans-serif" }}
          onFocus={e=>{ e.target.style.borderColor="#EE6A1A"; e.target.style.background="var(--card-bg)"; }}
          onBlur={e=>{ e.target.style.borderColor="var(--border-color)"; e.target.style.background="var(--hover-bg)"; }}/>

        <div style={{ display:"flex", background:"var(--hover-bg)", borderRadius:8, padding:3, gap:2 }}>
          {[["meus","Meus leads"],["todos","Todos"]].map(([id,label])=>(
            <button key={id} onClick={()=>setFiltro(id)} style={{ padding:"5px 12px", borderRadius:6, fontSize:12, fontWeight:filtro===id?700:400, cursor:"pointer", background:filtro===id?"var(--card-bg)":"transparent", border:filtro===id?"1px solid var(--border-color)":"none", color:filtro===id?"var(--text-primary)":"var(--text-secondary)", boxShadow:filtro===id?"0 1px 3px rgba(0,0,0,.06)":"none" }}>
              {label}
            </button>
          ))}
        </div>

        <span style={{ fontSize:13, color:"var(--text-secondary)" }}>{filtered.length} lead{filtered.length!==1?"s":""}</span>

        <button onClick={()=>setModal({})} style={{ marginLeft:"auto", background:"#EE6A1A", border:"none", borderRadius:8, padding:"7px 18px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", boxShadow:"0 2px 8px #EE6A1A44" }}
          onMouseEnter={e=>e.currentTarget.style.background="#0060c0"}
          onMouseLeave={e=>e.currentTarget.style.background="#EE6A1A"}>
          + Novo lead
        </button>
      </div>

      {/* Board */}
      <div style={{ display:"flex", gap:12, padding:"16px 20px 40px", overflowX:"auto", minHeight:"calc(100vh - 80px)" }}>
        {STAGES.map(stage=>{
          const stageLeads = porStage(stage.id);
          const valor = totalValor(stage.id);
          const over  = dragOver===stage.id;

          return (
            <div key={stage.id}
              onDragOver={e=>{ e.preventDefault(); setDragOver(stage.id); }}
              onDragLeave={()=>setDragOver(null)}
              onDrop={e=>{ e.preventDefault(); const id=e.dataTransfer.getData("leadId"); if(id) moverStage(id,stage.id); setDragOver(null); }}
              style={{ flex:"0 0 260px", width:260, display:"flex", flexDirection:"column", background:over?stage.bg+"66":stage.bg+"33", borderRadius:10, border:`1.5px solid ${over?stage.color:stage.color+"44"}`, transition:"all .15s" }}>

              {/* Header coluna */}
              <div style={{ padding:"12px 14px 10px", borderBottom:`2px solid ${stage.color}44` }}>
                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:4 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:7 }}>
                    <div style={{ width:10, height:10, borderRadius:2, background:stage.color }}/>
                    <span style={{ fontSize:13, fontWeight:700, color:"var(--text-primary)" }}>{stage.label}</span>
                    <span style={{ background:stage.color+"22", color:stage.color, borderRadius:99, fontSize:11, fontWeight:700, padding:"1px 7px" }}>{stageLeads.length}</span>
                  </div>
                </div>
                {valor>0&&<div style={{ fontSize:12, fontWeight:700, color:stage.color }}>{fmt(valor)}</div>}
              </div>

              {/* Cards */}
              <div style={{ flex:1, padding:"10px 10px 8px", overflowY:"auto", minHeight:80 }}>
                {loading&&<div style={{ padding:20, textAlign:"center", color:"var(--text-muted)", fontSize:12 }}>...</div>}
                {!loading&&stageLeads.length===0&&(
                  <div style={{ padding:"20px 10px", textAlign:"center", color:"var(--text-muted)", fontSize:12, border:`1.5px dashed ${stage.color}44`, borderRadius:8 }}>
                    Arraste um lead aqui
                  </div>
                )}
                {stageLeads.map(lead=>(
                  <KanbanCard key={lead._id} lead={lead} onOpen={setModal} onStageChange={moverStage}/>
                ))}
              </div>

              {/* Footer */}
              <div style={{ padding:"6px 10px 10px" }}>
                <button onClick={()=>setModal({stage:stage.id})} style={{ width:"100%", background:"transparent", border:`1.5px dashed ${stage.color}66`, borderRadius:7, padding:"7px 0", color:stage.color, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',sans-serif" }}
                  onMouseEnter={e=>{ e.currentTarget.style.background=stage.bg; }}
                  onMouseLeave={e=>{ e.currentTarget.style.background="transparent"; }}>
                  + Adicionar
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {modal!==null&&<ModalLead lead={Object.keys(modal).length?modal:null} onClose={()=>setModal(null)} onSave={salvarLead} onDelete={excluirLead}/>}
    </div>
  );
}
